import { Injectable } from '@angular/core';
import { LoadingController, Loading } from 'ionic-angular';

/*
  Generated class for the MasterService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class LoadingService {

  loader:Loading = null;
  loadingPresented = false;

  constructor(
     public loadingCtrl: LoadingController,
  	) {}

  /**
   * ローディング開始
   */
  present(text, options?:object) {

    if(!this.loadingPresented){ //多重起動抑止
      this.loader = this.loadingCtrl.create({
        content: text
      });
      this.loader.present();
      this.loadingPresented = true;
    }
  }

  /**
   * ローディング終了
   */
  dissmiss(){

    if(this.loadingPresented){ //起動時のみdismiss
      this.loader.dismiss();
      this.loadingPresented = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/loading-service.ts